import { inject, Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SettingsService } from '../services/settings.service';
import { Media } from '../models/page-components/media.model';

@Pipe({
  name: 'image',
  standalone: true,
})
export class ImagePipe implements PipeTransform {
  settingsService = inject(SettingsService);
  adminDomain = environment.imagePath;
  isMobile = false;

  transform(
    imageUrl: string,
    imageWidth: number,
    image: Media,
    mode: string = 'fill',
    imageHeight: number = 0,
    fixedHeight = false,
    quality = 100,
  ) {
    // console.log('imageUrl :>> ', imageUrl);
    // console.log('imageWidth :>> ', imageWidth);
    // console.log('image.ImageRatio :>> ', image.ImageRatio);
    // console.log('image :>> ', image);
    // console.log('mode :>> ', mode);
    // console.log('imageHeight :>> ', imageHeight);
    // console.log('fixedHeight :>> ', fixedHeight);

    this.isMobile = this.settingsService.getMobileStatus();
    const isTablet = this.settingsService.getTabletStatus();

    if (!imageUrl) {
      return '';
    }

    // fix mobile images
    if (this.isMobile) {
      if (imageWidth > 390) {
        if (imageHeight > 0) {
          imageHeight = Math.floor((390 / imageWidth) * imageHeight);
        }
        imageWidth = 390;
      }
    } else if (isTablet) {
      if (imageWidth > 989) {
        if (imageHeight > 0) {
          imageHeight = Math.floor((989 / imageWidth) * imageHeight);
        }
        imageWidth = 989;
      }
    }

    let size = '';
    if (imageWidth !== 0 && image.ImageRatio && image.ImageRatio > 0) {
      if (image.Width && image.Width > 0 && image.Width < imageWidth) {
        imageWidth = image.Width;
      }

      const imagePath = environment.imgFxActive
        ? environment.imgFxDomain.replace('{mode}', mode + '.webp') + imageUrl
        : environment.apiDomain + 'upload/media/' + imageUrl;

      if (fixedHeight) {
        size = imageHeight
          ? Math.floor(imageHeight / image.ImageRatio) + 'x' + imageHeight
          : '1200x630';
        return imagePath.replace(
          '{size}',
          quality < 100 ? size + '.q-' + quality : size,
        );
      }

      if (imageHeight > 0) {
        size = imageWidth + 'x' + imageHeight;
        return imagePath.replace(
          '{size}',
          quality < 100 ? size + '.q-' + quality : size,
        );
      }

      size = imageWidth + 'x' + Math.floor(imageWidth * image.ImageRatio);
      return imagePath.replace(
        '{size}',
        quality < 100 ? size + '.q-' + quality : size,
      );
    }

    return imageUrl.substr(0, 4) === 'http'
      ? imageUrl
      : this.adminDomain + imageUrl;
  }
}
